import axios from "axios";

// const endPoints = "http://localhost:4573/api";
export const endPoint = "https://shopwithmhizgee.onrender.com/api";


export const createUser = async ({ name, email, password }: any) => {
  await axios
    .post(`${endPoint}/users/register`, {
      name,
      email,
      password,
    })
    .then((res) => res.data);
};

export const getAllProduct = async () => {
  return await axios
    .get(`${endPoint}/products/allproducts`)
    .then((res) => res.data);
};

export const SingleProduct = async (id: any) => {
  return await axios
    .get(`${endPoint}/products/allproducts/${id}`)
    .then((res) => res.data);
};


//category
export const getAllCategory= async () => {
  return await axios
    .get(`${endPoint}/category/all-category`)
    .then((res) => res.data);
};
export const getOneCategory= async (catId : any) => {
  return await axios
    .get(`${endPoint}/category/all-category/${catId}`)
    .then((res) => res.data);
};